<div class="msg">
  <span i18n="@@unauthorized">You are not authorized.</span>
</div>
